import { withLoginChecked } from '@/hoc/withLogin';
import { AnyObj } from '@/utils';
import React, { ComponentType, Suspense } from 'react';

export type IOption = {
  src: string;
};

export type LoaderType<P extends AnyObj = any> = () => Promise<{
  default: React.ComponentType<P>;
}>;

export interface lazyLoadProps<P extends AnyObj> {
  loader: LoaderType<P>;
  needToken?: boolean;
  // 是否需要进行ref转发
  isRef?: boolean;
}

const noop = () => null;

export const lazyLoad = (option: lazyLoadProps<any>): ComponentType => {
  const { loader, needToken, isRef } = option;
  const enhanceLoader = async ()=>{
    const module  = await loader()
    const Comp = module.default;
    
    const isClassComponent = Boolean(Comp.prototype && Comp.prototype.isReactComponent);
  }
  
  const Com = React.lazy(loader);

  const ComMid = () => {
    return (
      <Suspense fallback={noop()}>
        <Com />
      </Suspense>
    );
  };
  // 特殊处理需要
  if (isRef) {
    enhanceLoader();
    class LazyLoad extends React.Component<any, any> {
      render() {
        const { withRef, ...resProps } = this.props;
        return <Com {...resProps} ref={withRef} />;
      }
    }

    return React.forwardRef((props, ref) => {
      return <LazyLoad {...props} withRef={ref} />;
    });
  }

  return needToken ? withLoginChecked(ComMid) : ComMid;
};
